// extracted by mini-css-extract-plugin
module.exports = {"top":"style_top__2mocG","title":"style_title__NFQlV","note":"style_note__reKoi","btns":"style_btns__34N8K","button":"style_button__NTNK9"};